import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {HeaderComponent} from "./components/header/header.component";
import {RouterModule} from "@angular/router";
import { BannerComponent } from './components/banner/banner.component';
import { PrimeiroTextoComponent } from './components/primeiro-texto/primeiro-texto.component';
import { VideoComponent } from './components/video/video.component';
import { SegundoTextoComponent } from './components/segundo-texto/segundo-texto.component';
import { GaleriaComponent } from './components/galeria/galeria.component';
import {SlickCarouselModule} from "ngx-slick-carousel";
import { FooterComponent } from './components/footer/footer.component';
import {BrowserModule} from "@angular/platform-browser";
import { FixarHeaderDirective } from './components/header/fixar-header.directive';



@NgModule({
  declarations: [
    HeaderComponent,
    BannerComponent,
    PrimeiroTextoComponent,
    VideoComponent,
    SegundoTextoComponent,
    GaleriaComponent,
    FooterComponent,
    FixarHeaderDirective

  ],
  imports: [
    CommonModule,
    RouterModule,
    SlickCarouselModule,
  ],
  exports: [
    HeaderComponent,
    BannerComponent,
    PrimeiroTextoComponent,
    VideoComponent,
    GaleriaComponent,
    SegundoTextoComponent,
    FooterComponent,
    FixarHeaderDirective
  ]
})
export class SharedModule { }
